import { useEffect } from 'react';

export default function usePortfolioMotion(ref) {
  useEffect(() => {
    const root = ref.current;
    if(!root || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if(entry.isIntersecting){entry.target.dataset.revealState='visible';observer.unobserve(entry.target);} }),{threshold:0.08});
    root.querySelectorAll('[data-reveal]').forEach(node => {node.dataset.revealState='pending';observer.observe(node);});
    return () => observer.disconnect();
  },[ref]);
}
